import { findVirginiaPlace } from './virginia-places.js';
/**
 * The words for a list of picked places, in the order they were picked: a city by its name, a ZIP code area as
 * "ZIP" and the number, joined with ", " ("Norfolk, ZIP 23220").
 *
 * A code that is in no list of ours (one of Google's ids, saved before the list existed) has no words here and is
 * left out, so the text never says "Pick this place again". The same wording the places picker shows on a pill.
 * Nothing here is about a person: it reads the app's own list.
 */
export function servicePlacesWords(places) {
    return places
        .flatMap((place) => {
        const listed = findVirginiaPlace(place.placeId);
        return listed === undefined ? [] : [listed.kind === 'zip' ? `ZIP ${listed.name}` : listed.name];
    })
        .join(', ');
}
//# sourceMappingURL=service-place-words.js.map